// extracted by mini-css-extract-plugin
module.exports = {"root":"document-page_root__T093I","content":"document-page_content__gPmmq"};